
// import socketService from './socketService';

// class SocketEvents {
//   constructor() {
//     this.callbacks = {};
//     this.isRegistered = false;
//   }

//   registerEvents(handlers = {}) {
//     // ✅ Prevent double registration
//     if (this.isRegistered) {
//       console.log('⚠️ Events already registered, skipping...');
//       return;
//     }

//     this.callbacks = handlers;

//     socketService.on('connected_ack', (data) => {
//       console.log('✅ User Connected ACK:', data);
//       this.callbacks.onUserConnected?.(data);
//     });

//     socketService.on('messages_list', (data) => {
//       console.log('📥 Messages List received:', data);
//       this.callbacks.onMessagesList?.(data);
//     });

//     socketService.on('message_sent', (data) => {
//       console.log('📩 Message Sent:', data);
//       this.callbacks.onMessageSent?.(data);
//     });

//     socketService.on('message_delivered_ack', (data) => {
//       console.log('✅ Message Delivered ACK:', data);
//       this.callbacks.onMessageDelivered?.(data);
//     });

//     socketService.on('message_received', (messageId) => {
//       console.log('📨 Message Received:', messageId);
//       this.callbacks.onMessageReceived?.(messageId);
//     });

//     socketService.on('messages_read', (data) => {
//       console.log('👁️ Messages Read:', data);
//       this.callbacks.onMessagesRead?.(data);
//     });

//     socketService.on('new_conversation', (data) => {
//       console.log('🆕 New Conversation:', data);
//       this.callbacks.onNewConversation?.(data);
//     });

//     socketService.on('joined_conversation', (data) => {
//       console.log('✅ Joined Conversation:', data);
//       this.callbacks.onJoinedConversation?.(data);
//     });

//     socketService.on('typing_start', (data) => {
//       console.log('⌨️ User typing:', data);
//       this.callbacks.onTypingStart?.(data);
//     });

//     socketService.on('typing_stop', (data) => {
//       console.log('⌨️ User stopped typing:', data);
//       this.callbacks.onTypingStop?.(data);
//     });

//     socketService.on('user_online', (data) => {
//       console.log('👤 User Online:', data);
//       this.callbacks.onUserOnline?.(data);
//     });

//     socketService.on('user_offline', (data) => {
//       console.log('👤 User Offline:', data);
//       this.callbacks.onUserOffline?.(data);
//     });

//     this.isRegistered = true;
//     console.log('✅ All socket events registered');
//   }

//   userConnected(userId) {
//     console.log('📤 Emitting user_connected:', userId);
//     socketService.emit('user_connected', { user_id: parseInt(userId) });
//   }

//   joinConversation(conversationId) {
//     console.log('📤 Emitting join_conversation:', conversationId);
//     socketService.emit('join_conversation', { 
//       conversation_id: parseInt(conversationId) 
//     });
//   }

//   getMessages(conversationId, userId) {
//     console.log('📤 Emitting get_messages:', { conversationId, userId });
//     socketService.emit('get_messages', { 
//       conversation_id: parseInt(conversationId),
//       user_id: parseInt(userId)
//     });
//   }

//   sendMessage(conversationId, senderId, receiverId, messageText) {
//     console.log('📤 Emitting send_message:', {
//       conversationId,
//       senderId,
//       receiverId,
//       messageText
//     });
//     socketService.emit('send_message', {
//       conversation_id: parseInt(conversationId),
//       sender_id: parseInt(senderId),
//       receiver_id: parseInt(receiverId),
//       message_text: messageText
//     });
//   }

//   markMessagesAsRead(conversationId, userId) {
//     console.log('📤 Emitting message_seen:', { conversationId, userId });
//     socketService.emit('message_seen', {
//       conversation_id: parseInt(conversationId),
//       user_id: parseInt(userId)
//     });
//   }

//   startTyping(conversationId, userId) {
//     socketService.emit('typing_start', {
//       conversation_id: parseInt(conversationId),
//       user_id: parseInt(userId)
//     });
//   }

//   stopTyping(conversationId, userId) {
//     socketService.emit('typing_stop', {
//       conversation_id: parseInt(conversationId),
//       user_id: parseInt(userId)
//     });
//   }

//   unregisterEvents() {
//     if (!this.isRegistered) return;

//     const events = [
//       'connected_ack',
//       'messages_list',
//       'message_sent',
//       'message_delivered_ack',
//       'message_received',
//       'messages_read',
//       'new_conversation',
//       'joined_conversation',
//       'typing_start',
//       'typing_stop',
//       'user_online',
//       'user_offline'
//     ];

//     events.forEach(event => {
//       socketService.removeAllListeners(event);
//     });

//     this.isRegistered = false;
//     this.callbacks = {};
//     console.log('🧹 All socket events unregistered');
//   }
// }

// export default new SocketEvents();


// import socketService from './socketService';

// class SocketEvents {
//   constructor() {
//     this.callbacks = {};
//     this.isRegistered = false;
//     this.eventHandlers = {};
//   }

//   registerEvents(handlers = {}) {
//     // ✅ Allow re-registration after socket reconnect
//     if (this.isRegistered) {
//       console.log('⚠️ Events already registered. Updating callbacks...');
//       this.callbacks = { ...this.callbacks, ...handlers };
//       return;
//     }

//     this.callbacks = handlers;

//     // ✅ Store handlers for potential cleanup (REMOVED typing_start and typing_stop)
//     this.eventHandlers = {
//       connected_ack: (data) => {
//         console.log('✅ User Connected ACK:', data);
//         this.callbacks.onUserConnected?.(data);
//       },

//       messages_list: (data) => {
//         console.log('📥 Messages List received:', data);
//         this.callbacks.onMessagesList?.(data);
//       },

//       message_sent: (data) => {
//         console.log('📩 Message Sent:', data);
//         this.callbacks.onMessageSent?.(data);
//       },

//       message_delivered_ack: (data) => {
//         console.log('✅ Message Delivered ACK:', data);
//         this.callbacks.onMessageDelivered?.(data);
//       },

//       message_received: (messageId) => {
//         console.log('📨 Message Received:', messageId);
//         this.callbacks.onMessageReceived?.(messageId);
//       },

//       messages_read: (data) => {
//         console.log('👁️ Messages Read:', data);
//         this.callbacks.onMessagesRead?.(data);
//       },

//       new_conversation: (data) => {
//         console.log('🆕 New Conversation:', data);
//         this.callbacks.onNewConversation?.(data);
//       },

//       joined_conversation: (data) => {
//         console.log('✅ Joined Conversation:', data);
//         this.callbacks.onJoinedConversation?.(data);
//       },

//       user_online: (data) => {
//         console.log('👤 User Online:', data);
//         this.callbacks.onUserOnline?.(data);
//       },

//       user_offline: (data) => {
//         console.log('👤 User Offline:', data);
//         this.callbacks.onUserOffline?.(data);
//       }
//     };

//     // ✅ Register all event handlers
//     Object.entries(this.eventHandlers).forEach(([event, handler]) => {
//       socketService.on(event, handler);
//     });

//     this.isRegistered = true;
//     console.log('✅ All socket events registered');
//   }

//   // ✅ Helper method to check if socket is ready
//   _checkSocket() {
//     if (!socketService.isSocketConnected()) {
//       console.warn('⚠️ Socket not connected. Event may not be sent.');
//       return false;
//     }
//     return true;
//   }

//   userConnected(userId) {
//     console.log('📤 Emitting user_connected:', userId);
//     return socketService.emit('user_connected', { user_id: parseInt(userId) });
//   }

//   joinConversation(conversationId) {
//     console.log('📤 Emitting join_conversation:', conversationId);
//     return socketService.emit('join_conversation', { 
//       conversation_id: parseInt(conversationId) 
//     });
//   }

//   getMessages(conversationId, userId) {
//     console.log('📤 Emitting get_messages:', { conversationId, userId });
//     return socketService.emit('get_messages', { 
//       conversation_id: parseInt(conversationId),
//       user_id: parseInt(userId)
//     });
//   }

//   sendMessage(conversationId, senderId, receiverId, messageText) {
//     console.log('📤 Emitting send_message:', {
//       conversationId,
//       senderId,
//       receiverId,
//       messageText: messageText.substring(0, 50) + (messageText.length > 50 ? '...' : '')
//     });
//     return socketService.emit('send_message', {
//       conversation_id: parseInt(conversationId),
//       sender_id: parseInt(senderId),
//       receiver_id: parseInt(receiverId),
//       message_text: messageText
//     });
//   }

//   markMessagesAsRead(conversationId, userId) {
//     console.log('📤 Emitting message_seen:', { conversationId, userId });
//     return socketService.emit('message_seen', {
//       conversation_id: parseInt(conversationId),
//       user_id: parseInt(userId)
//     });
//   }

//   // ✅ REMOVED typing methods
//   // startTyping() and stopTyping() have been removed

//   // ✅ Clean unregister method
//   unregisterEvents() {
//     if (!this.isRegistered) {
//       console.log('⚠️ No events registered to unregister');
//       return;
//     }

//     const events = Object.keys(this.eventHandlers);
    
//     events.forEach(event => {
//       socketService.removeAllListeners(event);
//     });

//     this.isRegistered = false;
//     this.callbacks = {};
//     this.eventHandlers = {};
//     console.log('🧹 All socket events unregistered');
//   }

//   // ✅ Re-register events after reconnection
//   reRegisterEvents() {
//     console.log('🔄 Re-registering socket events after reconnection...');
//     this.isRegistered = false;
//     this.registerEvents(this.callbacks);
//   }
// }

// export default new SocketEvents();


import socketService from './socketService';

class SocketEvents {
  constructor() {
    this.callbacks = {};
    this.isRegistered = false;
    this.eventHandlers = {};
  }

  registerEvents(handlers = {}) {
    if (this.isRegistered) {
      console.log('⚠️ Events already registered. Updating callbacks...');
      this.callbacks = { ...this.callbacks, ...handlers };
      return;
    }

    this.callbacks = handlers;

    this.eventHandlers = {
      connected_ack: (data) => {
        console.log('✅ User Connected ACK:', data);
        this.callbacks.onUserConnected?.(data);
      },

      messages_list: (data) => {
        console.log('📥 Messages List received:', data);
        this.callbacks.onMessagesList?.(data);
      },

      message_sent: (data) => {
        console.log('📩 Message Sent:', data);
        this.callbacks.onMessageSent?.(data);
      },

      message_delivered_ack: (data) => {
        console.log('✅ Message Delivered ACK:', data);
        this.callbacks.onMessageDelivered?.(data);
      },

      message_received: (messageId) => {
        console.log('📨 Message Received:', messageId);
        this.callbacks.onMessageReceived?.(messageId);
      },

      messages_read: (data) => {
        console.log('👁️ Messages Read:', data);
        this.callbacks.onMessagesRead?.(data);
      },

      new_conversation: (data) => {
        console.log('🆕 New Conversation:', data);
        this.callbacks.onNewConversation?.(data);
      },

      joined_conversation: (data) => {
        console.log('✅ Joined Conversation:', data);
        this.callbacks.onJoinedConversation?.(data);
      },

      user_online: (data) => {
        console.log('👤 User Online:', data);
        this.callbacks.onUserOnline?.(data);
      },

      user_offline: (data) => {
        console.log('👤 User Offline:', data);
        this.callbacks.onUserOffline?.(data);
      },

      // ✅ ADD THIS EVENT HANDLER for inquiry_created response
      inquiry_created: (data) => {
        console.log('✅ Inquiry Created:', data);
        this.callbacks.onInquiryCreated?.(data);
      }
    };

    Object.entries(this.eventHandlers).forEach(([event, handler]) => {
      socketService.on(event, handler);
    });

    this.isRegistered = true;
    console.log('✅ All socket events registered');
  }

  _checkSocket() {
    if (!socketService.isSocketConnected()) {
      console.warn('⚠️ Socket not connected. Event may not be sent.');
      return false;
    }
    return true;
  }

  userConnected(userId) {
    console.log('📤 Emitting user_connected:', userId);
    return socketService.emit('user_connected', { user_id: parseInt(userId) });
  }

  joinConversation(conversationId) {
    console.log('📤 Emitting join_conversation:', conversationId);
    return socketService.emit('join_conversation', { 
      conversation_id: parseInt(conversationId) 
    });
  }

  getMessages(conversationId, userId) {
    console.log('📤 Emitting get_messages:', { conversationId, userId });
    return socketService.emit('get_messages', { 
      conversation_id: parseInt(conversationId),
      user_id: parseInt(userId)
    });
  }

  sendMessage(conversationId, senderId, receiverId, messageText) {
    console.log('📤 Emitting send_message:', {
      conversationId,
      senderId,
      receiverId,
      messageText: messageText.substring(0, 50) + (messageText.length > 50 ? '...' : '')
    });
    return socketService.emit('send_message', {
      conversation_id: parseInt(conversationId),
      sender_id: parseInt(senderId),
      receiver_id: parseInt(receiverId),
      message_text: messageText
    });
  }

  markMessagesAsRead(conversationId, userId) {
    console.log('📤 Emitting message_seen:', { conversationId, userId });
    return socketService.emit('message_seen', {
      conversation_id: parseInt(conversationId),
      user_id: parseInt(userId)
    });
  }

  // ✅ ADD THIS NEW METHOD
  createInquiry(buyerId, propertyId, inquiryText) {
    console.log('📤 Emitting create_inquiry:', {
      buyerId,
      propertyId,
      inquiryText: inquiryText.substring(0, 50) + (inquiryText.length > 50 ? '...' : '')
    });
    
    return socketService.emit('create_inquiry', {
      buyer_id: parseInt(buyerId),
      property_id: parseInt(propertyId),
      inquiry_text: inquiryText
    });
  }

  unregisterEvents() {
    if (!this.isRegistered) {
      console.log('⚠️ No events registered to unregister');
      return;
    }

    const events = Object.keys(this.eventHandlers);
    
    events.forEach(event => {
      socketService.removeAllListeners(event);
    });

    this.isRegistered = false;
    this.callbacks = {};
    this.eventHandlers = {};
    console.log('🧹 All socket events unregistered');
  }

  reRegisterEvents() {
    console.log('🔄 Re-registering socket events after reconnection...');
    this.isRegistered = false;
    this.registerEvents(this.callbacks);
  }
}

export default new SocketEvents();

